/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: ApiKeysActions.tsx
 🗓️ Created: 2025-01-XX
 🧩 Description:
    Action buttons component for API Keys DataGrid rows.
────────────────────────────────────────────────────────────────*/

import { Edit, Copy, Trash2 } from 'lucide-react';
import { useI18n } from '../../../hooks/useI18n';
import { ApiKey } from '../types';
import SimpleTooltip from '../../../components/ui/SimpleTooltip';

interface ApiKeysActionsProps {
  item: ApiKey;
  onEdit: (item: ApiKey) => void;
  onDuplicate: (item: ApiKey) => void;
  onDelete: (item: ApiKey) => void;
}

export function ApiKeysActions({ item, onEdit, onDuplicate, onDelete }: ApiKeysActionsProps) {
  const { t } = useI18n();

  return (
    <div className="flex items-center gap-1.5">
      <SimpleTooltip content={t('apiKeys.tooltips.editApiKey')} position="top">
        <button
          type="button"
          onClick={() => onEdit(item)}
          aria-label={t('apiKeys.tooltips.editApiKey')}
          className="p-2 text-blue-600 hover:bg-blue-50 dark:text-blue-400 dark:hover:bg-blue-900/20"
        >
          <Edit className="h-4 w-4" />
        </button>
      </SimpleTooltip>
      <SimpleTooltip content={t('apiKeys.tooltips.duplicateApiKey')} position="top">
        <button
          type="button"
          onClick={() => onDuplicate(item)}
          aria-label={t('apiKeys.tooltips.duplicateApiKey')}
          className="p-2 text-green-600 hover:bg-green-50 dark:text-green-400 dark:hover:bg-green-900/20"
        >
          <Copy className="h-4 w-4" />
        </button>
      </SimpleTooltip>
      <SimpleTooltip content={t('apiKeys.tooltips.deleteApiKey')} position="top">
        <button
          type="button"
          onClick={() => onDelete(item)}
          aria-label={t('apiKeys.tooltips.deleteApiKey')}
          className="p-2 text-red-600 hover:bg-red-50 dark:text-red-400 dark:hover:bg-red-900/20"
        >
          <Trash2 className="h-4 w-4" />
        </button>
      </SimpleTooltip>
    </div>
  );
}

